module.exports = __webpack_public_path__ + "static/media/sprite_ring_text-classic.e7ac2a94.svg";